import React, { useEffect, useState } from "react";

import { ReactComponent as IconClose } from "../../../build/images/attendanceIcons/close-side-info.svg";
import { ReactComponent as IconClips } from "../../../build/images/chatIcons/Clips.svg";
import { ReactComponent as IconDOC } from "../../../build/images/type-files/IconDOC.svg";
import { ReactComponent as IconXLS } from "../../../build/images/type-files/IconXLS.svg";
import { ReactComponent as IconPDF } from "../../../build/images/type-files/IconPDF.svg";
import { ReactComponent as IconPPT } from "../../../build/images/type-files/IconPPT.svg";
import { ReactComponent as IconTXT } from "../../../build/images/type-files/IconTXT.svg";
import { ReactComponent as IconZIP } from "../../../build/images/type-files/IconZIP.svg";

const FileInStageArea = ({
  filesInStage,
  setFilesInStage,
  fileData,
  index,
}) => {
  const [isCloseBtnActive, setIsCloseBtnActive] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);

  const isImage = fileData.isImage;
  const isVideo = fileData.isVideo;
  const handleClick = () => {
    const newFiles = [...filesInStage];
    const indexOfFileToDelete = newFiles.findIndex((fileToDelete) => {
      return (
        fileToDelete.id === fileData.id &&
        (fileToDelete.idAtendimento === fileData.idAtendimento ||
          parseInt(fileToDelete.idAtendimento) ===
            parseInt(fileData.idAtendimento))
      );
    });
    newFiles.splice(indexOfFileToDelete, 1);
    setFilesInStage(newFiles);
  };
  const handleMouseEnter = () => {
    setIsCloseBtnActive(true);
  };
  const handleMouseLeave = () => {
    setIsCloseBtnActive(false);
  };
  const renderTypeIcons = (extension) => {
    switch (extension) {
      case "doc":
      case "docx":
        return <IconDOC />;

      case "xls":
      case "xlsx":
      case "xlsm":
        return <IconXLS />;

      case "pdf":
        return <IconPDF />;

      case "ppt":
      case "pptx":
      case "ppsx":
        return <IconPPT />;

      case "txt":
        return <IconTXT />;

      case "zip":
        return <IconZIP />;

      default:
        return <IconClips />;
    }
  };

  useEffect(() => {
    if (isVideo && !!fileData && !!fileData.file) {
      const video = document.createElement("video");
      video.src = URL.createObjectURL(fileData.file);
      video.crossOrigin = "anonymous";
      video.muted = true;
      video.playsInline = true;
      video.preload = "metadata";

      const handleLoadedMetadata = () => {
        const safeTime =
          video.duration > 1 ? 1 : Math.max(video.duration - 0.1, 0);
        video.currentTime = safeTime;
      };

      const handleSeeked = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 160;
        canvas.height = 90;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const thumb = canvas.toDataURL("image/png");
        setThumbnail(thumb);
      };

      video.addEventListener("loadedmetadata", handleLoadedMetadata);
      video.addEventListener("seeked", handleSeeked);

      return () => {
        video.removeEventListener("loadedmetadata", handleLoadedMetadata);
        video.removeEventListener("seeked", handleSeeked);
        URL.revokeObjectURL(video.src);
      };
    }
  }, [fileData, isVideo]);

  if (isImage) {
    return (
      <li
        className="files-stage-area__item"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img
          className="files-stage-area__item__image"
          src={URL.createObjectURL(fileData.file)}
          alt={fileData.name}
        />
        {isCloseBtnActive && (
          <button
            className="files-stage-area__item__close-btn"
            onClick={handleClick}
          >
            <IconClose />
          </button>
        )}
      </li>
    );
  } else if (isVideo) {
    return (
      <li
        className="files-stage-area__item"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {!!thumbnail ? (
          <img
            className="files-stage-area__item__image"
            src={thumbnail}
            alt={fileData.name}
          />
        ) : (
          <span>carregando...</span>
        )}
        {isCloseBtnActive && (
          <button
            className="files-stage-area__item__close-btn"
            onClick={handleClick}
          >
            <IconClose />
          </button>
        )}
      </li>
    );
  } else {
    const hasNameOfFile = !!fileData.name;
    const arrNameOfFileWithType = hasNameOfFile ? fileData.name.split(".") : [];
    const typeOfIcon =
      Array.isArray(arrNameOfFileWithType) && arrNameOfFileWithType.length > 0
        ? arrNameOfFileWithType[arrNameOfFileWithType.length - 1]
        : "default";
    return (
      <li
        className="files-stage-area__item no-image"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="files-stage-area__item__attach-container">
          <div>{renderTypeIcons(typeOfIcon)}</div>
          {hasNameOfFile && (
            <span className="files-stage-area__item__attach-container__text">
              {fileData.name}
            </span>
          )}
        </div>
        {isCloseBtnActive && (
          <button
            className="files-stage-area__item__close-btn"
            onClick={handleClick}
          >
            <IconClose />
          </button>
        )}
      </li>
    );
  }
};

export default FileInStageArea;
